import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {IndustryIcon} from 'shells/icon/svg/industry-icon';

import {appHistory} from '../../../history';

import {GraphQLSelect} from './graphql-select';
import {useGetIndustries} from './hooks/use-get-industries';

type Props = {
    selectedId: string | null | undefined;
    onChange: (selectedIndustry: any) => void;
    onClearValue: () => void;
    inputId: string;
    hasManageOption?: boolean;
    hideDividerWhenEmpty?: boolean;
    isDisabled?: boolean;
};

export function GraphQLSelectIndustries(props: Props) {
    const {isLoading, industries, errorMessage} = useGetIndustries();

    return (
        <GraphQLSelect
            inputId={props.inputId}
            selectedId={props.selectedId}
            onChange={props.onChange}
            onClearValue={props.onClearValue}
            isLoading={isLoading}
            models={industries}
            hasError={Boolean(errorMessage)}
            autoFocus={false}
            placeholder='Select…'
            controlIcon={IndustryIcon}
            // @ts-expect-error
            openMenuOnFocus={true}
            hideDividerWhenEmpty={props.hideDividerWhenEmpty}
            isDisabled={props.isDisabled}
            footerButton={
                props.hasManageOption
                    ? {
                          label: 'Manage industries',
                          onClick: () => {
                              appHistory.push('/setup/industry');
                          },
                      }
                    : undefined
            }
        />
    );
}
